import { useEntityDetailsDataStore } from '../use-entity-details-data-store';

export const useAddIncludedEntity = () => {
  const addIncludedEntity = useEntityDetailsDataStore(
    (state) => state.addIncludedEntity,
  );
  return addIncludedEntity;
};
